import { EmblaCarouselType } from 'embla-carousel';
import Image from 'next/image';
import { Ref } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { LightboxImage } from '../../types';

import { styles } from './ThumbnailsCarousel.styles';

export interface ThumbnailsCarouselProps {
  images: LightboxImage[];
  emblaRef: Ref<HTMLDivElement>;
  emblaMainApi?: EmblaCarouselType;
  className?: string;
  onThumbClick: (index: number) => void;
  selectedIndex: number;
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
}

export function ThumbnailsCarousel({
  images,
  emblaRef,
  emblaMainApi,
  onThumbClick,
  className,
  selectedIndex,
  prevBtnDisabled,
  nextBtnDisabled
}: ThumbnailsCarouselProps) {
  const slots = styles();

  const onPrevButtonClick = () => {
    emblaMainApi?.scrollPrev();
  };

  const onNextButtonClick = () => {
    emblaMainApi?.scrollNext();
  };

  return (
    <div className={slots.base({ className })}>
      <UiKitButtonBase
        onClick={onPrevButtonClick}
        className={slots.arrowButton({
          hide: prevBtnDisabled,
          className: 'rotate-180'
        })}
        rounded="full"
        color="ghost"
      >
        <ChevronIcon />
      </UiKitButtonBase>

      <div
        className={slots.viewport()}
        ref={emblaRef}
      >
        <div className={slots.carousel()}>
          {images.map((image, index) => (
            <div
              key={image.id}
              className={slots.slideContainer()}
            >
              <div className={slots.slide()}>
                <button
                  type="button"
                  className={slots.slideButton({
                    active: index === selectedIndex
                  })}
                  onClick={() => onThumbClick(index)}
                >
                  <Image
                    className={slots.image()}
                    src={image.src}
                    alt={image.alt}
                    fill
                  />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <UiKitButtonBase
        onClick={onNextButtonClick}
        className={slots.arrowButton({
          hide: nextBtnDisabled
        })}
        rounded="full"
        color="ghost"
      >
        <ChevronIcon />
      </UiKitButtonBase>
    </div>
  );
}
